import React, { useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';

import LoginPage from './components/Login';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrapperPage from './components/ScrapperPage';
import MailerPage from './components/MailerPage';
import ResumePage from './components/ResumePage';
import ResumeDataInsertPage from './components/ResumeDataInsertPage';
import ResumePdfPreviewPage from './components/ResumePdfPreviewPage';
import CandidatePage from './components/CandidatePage';
import FeedbackPage from './components/FeedbackPage';
import JobsPage from './components/JobsPage';
import AddJobPage from './components/AddJobPage';
import AddUser from './components/AddUser';
import JobDetailPage from './components/JobDetailPage';
import { useAuth } from './AuthContext';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/" replace />;
}

function AdminOnlyRoute({ children }) {
  const { user, isAdmin, loading } = useAuth();
  if (loading) return null;
  return user && isAdmin() ? children : <Navigate to="/candidates" replace />;
}

function HRAdminRoute({ children }) {
  const { user, isHR, loading } = useAuth();
  if (loading) return null;
  return user && isHR() ? children : <Navigate to="/candidates" replace />;
}

function PublicRoute({ children }) {
  // ResumePage is public, no authentication required
  return children;
}

function App() {
  const location = useLocation();
  const { setUser } = useAuth();
  const isLoginPage = location.pathname === '/';

  useEffect(() => {
    if (isLoginPage) {
      // Clear auth data
      setUser(null);
      localStorage.removeItem('auth_token');
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Disable back button
      window.history.pushState(null, '', window.location.href);
      const handlePopState = (e) => {
        if (window.location.pathname === '/') {
          window.history.pushState(null, '', window.location.href);
        }
      };
      window.addEventListener('popstate', handlePopState);
      return () => window.removeEventListener('popstate', handlePopState);
    }
  }, [isLoginPage, setUser]);

  return (
    <>
    <div className='app-container' >
    <div className='header'>
      {<Navbar />}
      </div>
      <div className="main-content"> 
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/resume" element={<PublicRoute><ResumePage /></PublicRoute>} />
          <Route path="/resume-update" element={<PrivateRoute><ResumeDataInsertPage /></PrivateRoute>} />
          <Route path="/resume-pdf-preview" element={<PrivateRoute><ResumePdfPreviewPage /></PrivateRoute>} />
          <Route path="/scrapper" element={<AdminOnlyRoute><ScrapperPage /></AdminOnlyRoute>} />
          <Route path="/mailer" element={<AdminOnlyRoute><MailerPage /></AdminOnlyRoute>} />
          {/* <Route path="/resume" element={<PrivateRoute><ResumePage /></PrivateRoute>} /> */}
          <Route path="/candidates" element={<PrivateRoute><CandidatePage /></PrivateRoute>} />
          <Route path="/jobs" element={<PrivateRoute><JobsPage /></PrivateRoute>} />
          <Route path="/add-job" element={<HRAdminRoute><AddJobPage /></HRAdminRoute>} />
          <Route path="/adduser" element={<HRAdminRoute><AddUser /></HRAdminRoute>} />
          <Route path="/feedback/:candidateId" element={<PrivateRoute><FeedbackPage /></PrivateRoute>} />
          <Route path="/job-detail" element={<PrivateRoute><JobDetailPage /></PrivateRoute>} />
          <Route path="/applied_candidate" element={<PrivateRoute><JobDetailPage /></PrivateRoute>} />
          
          {/* Role-based dashboard routes */}
          <Route path="/admin/dashboard" element={<PrivateRoute><div>Admin Dashboard - Coming Soon</div></PrivateRoute>} />
          <Route path="/hr/dashboard" element={<PrivateRoute><div>HR Dashboard - Coming Soon</div></PrivateRoute>} />
          <Route path="/recruiter/dashboard" element={<PrivateRoute><div>Recruiter Dashboard - Coming Soon</div></PrivateRoute>} />
          <Route path="/dashboard" element={<PrivateRoute><ScrapperPage /></PrivateRoute>} />
          
          <Route path="*" element={<h2>404 - Page Not Found</h2>} />
        </Routes>
      </div>
      <div className='footer'>
      {<Footer />}
      </div>
      </div>
    </>
  );
}

export default App;
